import { Box } from "@material-ui/core";
import { useContext } from "react";
import Steps from "../../../../components/steps/Steps";
import { CorpoClinicoContext } from "../../../../context/CorpoClinicoContext";
import FormBase from "../../../../forms/FormBase";
import InterestReasonsDataComponent from "../../../components/materialui/CorpoClinico/InterestReasonsDataComponent";

export default function InterestReasonsDataStep() {

    const { state, dispatch } = useContext(CorpoClinicoContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    return (
        <div>
            <Steps.StepTitle text="Questionário" />

            <Box mt = {2}>
                <InterestReasonsDataComponent InterestReasonsDataForm = { state.InterestReasonsDataForm } onInputChange = { onInputChange } />
            </Box>
        </div>
    );

}